// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import app from './App'
import api from './api/'
import App from './common/app'
import router from './router'
import Swiper from "swiper"
import "swiper/dist/css/swiper.min.css"
import UA from "./plugin/uaredirect.js"


Vue.config.productionTip = false

// 修改Vue原型
Vue.prototype.$bus = new Vue();


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<app/>',
  components: { app }
})

UA.uaredirect("https://m.dwnest.com/index");
document.querySelector("html").style.fontSize = `${
  (document.body.clientWidth / 1920) * 32
}px`;
window.onresize = function () {
  document.querySelector("html").style.fontSize = `${
    (document.body.clientWidth / 1920) * 32
  }px`;
};



// WEBPACK FOOTER //
// ./src/main.js